import { DependencyList, useCallback, useEffect, useState } from "react";

/** useMemo with async factory. */
export function useMemoAsync<T>(
  factory: () => Promise<Nil<T>>,
  deps: DependencyList,
): {
  data: Nil<T>;
  isLoading: boolean;
  error: Nil<any>;
} {
  const [data, setData] = useState<Nil<T>>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Nil<any>>(null);

  const factoryComputed = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await factory();
      setData(result);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, deps);

  useEffect(() => {
    factoryComputed();
  }, [factoryComputed]);

  return { data, isLoading, error };
}
